import { Injectable } from '@angular/core';
import { OnFieldChanged } from '../../configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { getRmsSpecificationPage, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { map, take } from 'rxjs/operators';
import { LoadPaymentTermsValues } from '../redux/payment-terms.actions';
import { _safe } from '../../../../../modules/shared/utils/safe-get.method';
import { getRmsRecipeSpecifications } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors';
import { getProducts } from '@ordersnproducts/modules/multiple-order-online/redux/selectors/orders-catalogs.selector';
import { FormGroup } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

@Injectable()
export class LoadPaymentTermsService implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: any): void {
    this.store
      .select(getRmsSpecificationPage)
      .pipe(
        map((store) => {
          if (!value) {
            return;
          }
          const productCode = value;
          const contractCode = _safe(
            () =>
              store.productsOpenPlatformState.availableProducts.find((product) => product.productCode === productCode)
                .contracts[0].contractCode,
          );
          this.store.dispatch(new LoadPaymentTermsValues({ productCode, contractCode }));
        }),
        take(1),
      )
      .subscribe();
  }
}

/**
 * Service that listens for field changes and dispatches actions to load
 * payment terms based on selected product and contract codes from the
 * getRmsRecipeSpecifications.
 */
@Injectable()
export class LoadPaymentTermsRepeatService implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(): void {
    this.store
      .select(getRmsRecipeSpecifications)
      .pipe(
        map((store) => {
          if (!store || !store.values) {
            return;
          }
          const productCode = _safe(() => store[0].values.productSelect);
          const contractCode = _safe(() => store[0].values.contractSelect);
          this.store.dispatch(new LoadPaymentTermsValues({ productCode, contractCode }));
        }),
        take(1),
      )
      .subscribe();
  }
}

/**
 * Service that listens for field changes and dispatches actions to load
 * payment terms based on selected product and contract codes for MOO
 * .
 */
@Injectable()
export class LoadPaymentTermsMOOService implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: any, formGroup: FormGroup): void {
    this.store
      .select(getProducts)
      .pipe(
        map((prducts) => {
          if (!prducts) {
            return;
          }
          const productCode = _safe(() => formGroup.get(SpecFieldNames.MIX).value);
          const contractCode = _safe(() => formGroup.get(SpecFieldNames.CONTRACT).value);
          if (!productCode || !contractCode) {
            return;
          }
          this.store.dispatch(new LoadPaymentTermsValues({ productCode, contractCode }));
        }),
        take(1),
      )
      .subscribe();
  }
}
